import axios from '@/services/api';


export const getTypes = async ({ commit }, params) => {
    commit('setTypes', []);
    const response = await axios.get('/point_types', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setTypes', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getTypeById = async ({ commit }, id) => {
    commit('setCurrentType', null);
    const response = await axios.get(`/point_types/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentType', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {
    return await axios.post("types",   payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    return await axios.put("types/" + payload.id, payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const deleteType = async ({ commit }, id) => {

    await axios.delete(`/point_types/${id}`)

    try {
        commit('setLoading', false);
    } catch (e) {
        console.log(e);
    }
};

